import { currencyToCurrencySymbol, formatCurrency, isCustomCurrencyFormatterInitialised, } from '../../helpers';
import { isPaidPlanActive, serverPricingToClientPrice } from './price';
export const isHiddenPlansOnly = (isHasSinglePayment, challengePaidPlans) => {
    return (!isHasSinglePayment &&
        challengePaidPlans.length &&
        !challengePaidPlans.find(isPaidPlanActive));
};
// this hell from this: https://jira.wixpress.com/browse/OPROG-3582
const FALLBACK_FORMATTER_LIST = ['NZD', 'CAD'];
export const serverPricingToClientPriceAndCurrencyString = (serverPricing) => {
    if (!serverPricing || !serverPricing.singlePayment) {
        return '';
    }
    if (!FALLBACK_FORMATTER_LIST.includes(serverPricing.singlePayment.price.currency.toLocaleUpperCase()) &&
        isCustomCurrencyFormatterInitialised()) {
        return formatCurrency({
            currency: serverPricing.singlePayment.price.currency,
            value: serverPricing.singlePayment.price.amount,
        });
    }
    const currencySymbol = currencyToCurrencySymbol(serverPricing.singlePayment.price.currency);
    const price = serverPricingToClientPrice(serverPricing);
    return `${currencySymbol}${price}`;
};
export const serverPricingToClientPriceAndCurrencyStringV3 = (price) => {
    if (!price) {
        return '';
    }
    if (!FALLBACK_FORMATTER_LIST.includes(price.currency.toLocaleUpperCase()) &&
        isCustomCurrencyFormatterInitialised()) {
        return formatCurrency({
            currency: price.currency,
            value: price.value,
        });
    }
    const currencySymbol = currencyToCurrencySymbol(price.currency);
    return `${currencySymbol}${price.value}`;
};
//# sourceMappingURL=pp.js.map